import { Button, Empty, message, Modal, Pagination } from 'antd'
import { inject, observer } from 'mobx-react'
import React, { useCallback, useEffect, useState } from 'react'
import TableComponent from '../../components/Common/TableComponent'
import {
  QuestionCircleOutlined,
  EditOutlined,
  DeleteOutlined,
} from '@ant-design/icons'
import ManagerInventoryUpdate from './ManagerInventoryUpdate'
import { TableBottomPaginationBlock } from '../../components/Common/Table'

const { confirm } = Modal

const ManagerInventoryTemplateList = props => {
  const [isLoading, setIsLoading] = useState(false)
  const [isVisibleUpdateModal, setIsVisibleUpdateModal] = useState(false)
  const [isVisibleApplyModal, setIsVisibleApplyModal] = useState(false)

  const { selectPeopleStore, authenticationStore } = props
  const { originDepartmentWithUserList, companyCode } = selectPeopleStore

  const { managerInventoryStore } = props
  const {
    managerInventoryList,
    managerInventoryLists,
    pageIndex,
    pageSize,
    totalCountInvent,
  } = managerInventoryStore
  const [selectedTemplateId, setSelectedTemplateId] = useState({})

  useEffect(() => {
    ;(async () => {
      await loadManagerInventoryList()
    })()
  }, [pageIndex, pageSize])

  useEffect(() => {
    ;(async () => {
      if (companyCode) {
        try {
          await selectPeopleStore.getDepartmentWithUsers()
        } catch (err) {
          console.log(err)
          message.error(err.vi || 'Đã có lỗi xảy ra!')
        }
      }
    })()
  }, [companyCode])

  useEffect(() => {
    if (authenticationStore.currentUser) {
      selectPeopleStore.companyCode = authenticationStore.currentCompanyCode()
    }
  }, [authenticationStore.currentUser])

  const loadManagerInventoryList = async () => {
    try {
      setIsLoading(true)
      await managerInventoryStore.getManagerInventoryLists()
    } finally {
      setIsLoading(false)
    }
  }

  const handleOpenUpdateModal = id => {
    setIsVisibleUpdateModal(true)
    setSelectedTemplateId(id)
  }

  const handleCancelUpdateModal = () => {
    setIsVisibleUpdateModal(false)
  }

  const handleChangePageInventoryLeave = useCallback(
    p => {
      const pageIndex = p - 1
      managerInventoryStore.setFilter('pageIndex', pageIndex)
    },
    [managerInventoryStore]
  )

  const handleCancelApplyModal = () => {
    setIsVisibleApplyModal(false)
  }

  const handleOpenAppyModal = id => event => {
    setIsVisibleApplyModal(true)
    setSelectedTemplateId(id)
  }

  const handleDelete = async code => {
    try {
      setIsLoading(true)
      await managerInventoryStore.delete(code)
      await loadManagerInventoryList()
      message.success('Đã xóa!')
    } catch (err) {
      console.log(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      setIsLoading(false)
    }
  }

  const showConfirm = (e, code) => {
    e.stopPropagation()
    setIsVisibleUpdateModal(false)
    confirm({
      title: 'Bạn có chắc chắn muốn xóa Cấp duyệt này ?',
      icon: <QuestionCircleOutlined style={{ color: 'red' }} />,
      okText: 'Xóa',
      cancelText: 'Không',
      okType: 'danger',
      onOk: async () => {
        await handleDelete(code)
      },
    })
  }

  const tableColumns = [
    {
      title: 'Tên mẫu',
      render: record => <p style={{ marginBottom: '0px' }}>{record.name}</p>,
    },
    {
      title: 'Mô tả',
      width: 450,
      render: record => (
        <p style={{ marginBottom: '0px' }}>{record.description}</p>
      ),
    },
    {
      title: 'Thao tác',
      width: 100,
      align: 'center',
      //ignore onRow event
      onCell: record => {
        return {
          onClick: event => {
            event.stopPropagation()
          },
        }
      },
      render: record => (
        <div>
          <EditOutlined
            type={'vertical'}
            onClick={() => handleOpenUpdateModal(record.code)}
            style={{ marginRight: '4px' }}
          />

          <DeleteOutlined
            style={{ color: '#fc0000', marginLeft: '4px' }}
            onClick={e => showConfirm(e, record.code)}
          />
        </div>
      ),
    },
  ]

  return (
    <>
      <TableComponent
        rowKey={record => record.code}
        dataSource={managerInventoryStore.managerInventoryLists}
        columns={tableColumns}
        pagination={false}
        onRow={record => ({
          onClick: () => handleOpenUpdateModal(record.code),
        })}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={'Không có dữ liệu'}
            />
          ),
        }}
        loading={isLoading}
      />

      <TableBottomPaginationBlock>
        <Pagination
          current={pageIndex + 1}
          pageSize={pageSize}
          total={totalCountInvent}
          showSizeChanger={false}
          onChange={handleChangePageInventoryLeave}
        />
      </TableBottomPaginationBlock>

      <Modal
        width={1000}
        title={'Chỉnh sửa cấp duyệt'}
        visible={isVisibleUpdateModal}
        maskClosable={false}
        onCancel={handleCancelUpdateModal}
        footer={null}
        destroyOnClose>
        {isVisibleUpdateModal && (
          <ManagerInventoryUpdate
            onCancel={handleCancelUpdateModal}
            templateId={selectedTemplateId}
          />
        )}
      </Modal>
      {/* <Modal
        width={800}
        title={'Áp dụng mẫu'}
        visible={isVisibleApplyModal}
        maskClosable={false}
        onCancel={handleCancelApplyModal}
        footer={null}
        destroyOnClose>
        {isVisibleApplyModal && (
          <ApprovalTemplateApply
            templateId={selectedTemplateId}
            onCancel={handleCancelApplyModal}
          />
        )}
      </Modal> */}
    </>
  )
}

export default inject(
  'managerInventoryStore',
  'authenticationStore',
  'selectPeopleStore'
)(observer(ManagerInventoryTemplateList))
